import React from "react";
import Third from "../../components/Third"

function ThirdPage(){
    return (
        <div>
            < Third />
        </div>
    );
}

export default ThirdPage;